module.exports = __webpack_public_path__ + "img/imgTextAndImageLeftSection.7a7cb74c.webp";